// extracted by mini-css-extract-plugin
module.exports = {"main":"Develop_main__TorUa"};